// libs
import React, { memo, useEffect } from 'react';
import { styled } from '@nykaa/ui-components';

// components
import ButtonBase from '@nykaa/ui-components/Button';

// constants
import { TEXT } from './constants';

// analytics
import { onPageLoad } from './analytics';

// icon
import ImageBase from 'components/ImageV2';

// styles
const Container = styled.div`
  text-align: center;
  color: #000;
  padding: ${({ theme }) =>
    `0 ${theme.spacing.spacing200} ${theme.spacing.spacing80} ${theme.spacing.spacing100} `};
`;

const Image = styled(ImageBase)`
  background: transparent;
  width: 132px;
  height: 132px;
`;

const Info = styled.p`
  ${({ theme }) => theme.typography.titleMedium};
  margin: ${({ theme }) => theme.spacing.spacing40} 0;
`;

const Description = styled.div`
  ${({ theme }) => theme.typography.bodyMedium};
  margin-bottom: ${({ theme }) => theme.spacing.spacing80};
`;

const Button = styled(ButtonBase)`
  border-radius: ${({ theme }) => theme.borders.radius10};
`;

interface ISomethingWentWrongProps {
  onBack?: VoidFunction;
  className?: string;
  label?: string;
}

export const INFO_CLASSNAME = 'info';

function SomethingWentWrong({
  onBack,
  className = '',
  label = TEXT.BACK_LINK_LABEL,
}: ISomethingWentWrongProps) {
  const clickHandler = () => {
    if (onBack) {
      onBack();
    } else {
      window.location.href = '/';
    }
  };

  useEffect(() => {
    onPageLoad();
  }, []);

  return (
    <Container data-test={'something-went-wrong'} className={className}>
      <Image
        width={80}
        height={80}
        src="https://images-static.nykaa.com/nykdesignstudio-images/pub/media/something_went_wrong.svg"
      />
      <Info className={INFO_CLASSNAME}>{TEXT.INFO}</Info>
      <Description>{TEXT.DESCRIPTION}</Description>
      <Button kind="primary" size="large" shape="default" fullWidth onClick={clickHandler}>
        {label}
      </Button>
    </Container>
  );
}

export default memo(SomethingWentWrong);
